import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { DavinciCard } from "./DavinciGameBoard";
import { useMemo } from "react";
import { commonAction } from "../../slices/GameSlice";

const DavinciSelectBoard = () => {
  const dispatch = useDispatch();

  const {
    davinciCode: { drawCard, turnUser, turnStep },
    drawCardLocation,
    submitValue,
    openCard,
  } = useSelector(state => state.GameSlice);
  //  카드 개수 +1 의 선이 존재

  const cardStyle = { width: "23px", height: "21px" };

  const SelectList = useMemo(() => {
    let arr = [];
    const cards = [...turnUser?.cards].sort((a, b) => {
      return a?.locationIndex - b?.locationIndex;
    });

    arr.push({ type: "line", value: cards[0].value });
    cards.forEach(i => {
      arr.push({
        type: "card",
        value: i.value,
        label: i.label,
        color: i.color,
      });
      arr.push({ type: "line", value: i.value });
    });
    let lineIndex = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].type !== "line") {
        continue;
      }

      let left = i - 1;
      let right = i + 1;
      // 참일때 실행,
      // 타입이 카드가 아니거나, 카드인데 조커면 증가

      while (arr[left]?.label === "-" || arr[left]?.type !== "card") {
        if (!arr[left]) {
          break;
        }
        left -= 1;
      }
      while (arr[right]?.label === "-" || arr[right]?.type !== "card") {
        if (!arr[right]) {
          break;
        }
        right += 1;
      }

      arr[i].leftRange = arr[left]?.label >= 0 ? arr[left]?.label : -1;
      arr[i].rightRange = arr[right]?.label >= 0 ? arr[right]?.label : 12;
      arr[i].lineIndex = lineIndex;
      lineIndex += 1;
    }
    return arr;
  }, [turnUser]);

  const cardFilter = useMemo(() => turnUser?.cards, [turnUser]);
  //   뽑은 카드가 조커=> 아무데나 호버하고 아무데나 클릭할 수 있음
  //   누르는 순간 해당 라인의 밸류가 조커의 밸류
  // 조커가 아닐때의 호버 => drawCard의 value -1 보다 크고 value+1보다 작으면 hover (같거나 x)
  return turnStep === 0 ? (
    <>
      <CardRow>
        <span>위치선택:</span>
        {SelectList.map((item, index) => {
          // 카드가 조커거나, drawCard의 value가 라인 범위 안에 들어올때,
          // drawCard가 W면 leftValue <= drawValue <rightValue
          // drawCard가 B면 leftValue < drawValue <= rightValue

          let onHover;
          if (item.type === "line") {
            const checkJoker = drawCard.label === "-";

            const checkRange =
              drawCard.color === "B"
                ? drawCard.value <= item.rightRange &&
                  drawCard.value > item.leftRange
                : drawCard.value >= item.leftRange &&
                  drawCard.value < item.rightRange;

            if (checkJoker || checkRange) {
              onHover = true;
            }
          }

          const LineHandler = () => {
            if (onHover) {
              dispatch(
                commonAction({
                  target: "drawCardLocation",
                  value:
                    item.lineIndex === drawCardLocation ? null : item.lineIndex,
                })
              );
            }
          };

          return item.type === "line" ? (
            <LocationLine
              $background={drawCardLocation === item.lineIndex && "#137E43"}
              key={`${index}locationKey`}
              $onHover={onHover}
              onClick={LineHandler}
            />
          ) : (
            <SelectCard
              style={{ cursor: "default" }}
              key={`${index}locationKey`}
              $color={item?.color}>
              {item.label}
            </SelectCard>
          );
        })}
      </CardRow>
      <CardRow>
        <span style={{ width: "68px" }}>뽑은타일:</span>
        <DavinciCard style={cardStyle} $color={drawCard?.color}>
          {drawCard?.label}
        </DavinciCard>
      </CardRow>
    </>
  ) : turnStep === 1 || turnStep === 2 ? (
    <CardRow style={{ gap: "1px" }}>
      <span> 숫자선택:</span>

      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, "-"].map(i => (
        <SelectCard
          key={`${i}submitKey`}
          style={{
            border: submitValue === i && "2px solid #137E43",
            backgroundColor: submitValue === i && "#E7F1EC",
          }}
          onClick={() =>
            dispatch(
              commonAction({
                target: "submitValue",
                value: submitValue === i ? null : i,
              })
            )
          }>
          {i}
        </SelectCard>
      ))}
    </CardRow>
  ) : turnStep === 3 ? (
    <CardRow>
      <span>공개:</span>
      {cardFilter?.map((item, index) => {
        const checkReveal = item?.reveal;
        const checkOpen =
          openCard?.label === item?.label && openCard?.color === item?.color;
        const openHandler = () => {
          if (!checkReveal) {
            dispatch(
              commonAction({ target: "openCard", value: checkOpen ? {} : item })
            );
          }
        };

        return (
          <SelectCard
            style={{
              border: (checkReveal || checkOpen) && "1px solid #FF3333",

              backgroundColor: checkOpen && "rgba(255, 51, 51,0.2)",
            }}
            key={`${index}openCardsKey`}
            onClick={openHandler}>
            {item?.label}
          </SelectCard>
        );
      })}
    </CardRow>
  ) : null;
};

export default DavinciSelectBoard;

const CardRow = styled.div`
  display: flex;
  span {
    width: 64px;
  }
`;

const SelectCard = styled.div`
  background-color: ${({ $color }) => ($color === "B" ? "#d1d1d1" : "#fff")};
  width: 23px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid #8a8a8a;
  cursor: pointer;
`;

const LocationLine = styled.div`
  width: 4px;
  height: 21px;
  background-color: ${({ $background }) => $background};
  cursor: pointer;
  &:hover {
    background-color: ${({ $onHover }) => $onHover && "rgba(19, 126, 67, 0.5)"};
  }
`;
